import { AnthropicLogo } from "./Anthropic";
import { OpenAILogo } from "./OpenAI";
import { GeminiLogo } from "./Gemini";
import { MistralLogo } from "./Mistral";
import { DeepSeekLogo } from "./DeepSeek";
import { PerplexityLogo } from "./Perplexity";
import { CohereLogo } from "./Cohere";
import { KimiLogo } from "./Kimi";

export {
  AnthropicLogo,
  OpenAILogo,
  GeminiLogo,
  MistralLogo,
  DeepSeekLogo,
  PerplexityLogo,
  CohereLogo,
  KimiLogo,
};

export const LLM_MODELS = {
  delphine: { logo: AnthropicLogo, label: "Claude Sonnet 4.6 / Opus 4.8", provider: "Anthropic" },
  henri: { logo: OpenAILogo, label: "GPT-5.4 mini / GPT-5.5", provider: "OpenAI" },
  akilah: { logo: GeminiLogo, label: "Gemini 3.5 Flash", provider: "Google" },
  eva: { logo: MistralLogo, label: "Mistral Small / Large", provider: "Mistral AI" },
  ren: { logo: DeepSeekLogo, label: "DeepSeek V4 Flash", provider: "DeepSeek" },
  julien: { logo: PerplexityLogo, label: "Sonar / Sonar Pro", provider: "Perplexity" },
  imani: { logo: CohereLogo, label: "Cohere Command A", provider: "Cohere" },
  emile: { logo: AnthropicLogo, label: "Claude Sonnet 4.6", provider: "Anthropic" },
} as const;

export type LLMPersonaId = keyof typeof LLM_MODELS;
